import {
  APIQueryOptions,
  APIQueryResult,
  useAPIQuery,
} from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import {
  SuggestedDriversDTO,
  suggestedDriversSchema,
} from './SuggestedDriversDTO';

export function useSuggestedDrivers(
  loadGUID: null | string | undefined,
  options?: APIQueryOptions<SuggestedDriversDTO>,
): APIQueryResult<SuggestedDriversDTO> {
  return useAPIQuery(
    ['loads', 'suggested-drivers', { guid: loadGUID }],
    () =>
      requestCarrierAPI([
        'GET /internal/web/loads/{guid}/suggested-drivers/',
        { guid: loadGUID },
      ]),
    { schema: suggestedDriversSchema, ...options },
  );
}
